import { Star, Users } from 'lucide-react';
import { useAnimationLoop } from './useOnboardingAnim';
import { DEMO_ROOT_CLASS } from './onboardingLayout';

const PATIENTS_PHASES = [1000, 1000, 1000, 1000, 1200];

export default function PatientsDemoAnimation() {
  const phase = useAnimationLoop(PATIENTS_PHASES);

  const showFavorites = phase >= 1;
  const khalidFavorited = phase >= 2;
  const khalidSelected = phase >= 3;

  return (
    <div className={DEMO_ROOT_CLASS}>
      <div className="flex h-full w-full flex-col justify-center space-y-1.5 px-1 sm:space-y-2">
      <div className="flex gap-2">
        <span
          className={`rounded-full px-2.5 py-1 text-[9px] font-semibold transition-colors duration-300 ${
            !showFavorites ? 'bg-primary text-white' : 'bg-gray-100 text-gray-600'
          }`}
        >
          All (12)
        </span>
        <span
          className={`rounded-full px-2.5 py-1 text-[9px] font-semibold transition-colors duration-300 ${
            showFavorites ? 'bg-primary text-white' : 'bg-gray-100 text-gray-600'
          }`}
        >
          Favorites (3)
        </span>
      </div>

      <div
        className={`flex items-center gap-2 rounded-lg border bg-white p-2 shadow-sm transition-all duration-400 ${
          phase >= 4 ? 'border-primary-ring scale-[1.02]' : 'border-gray-200 scale-100'
        }`}
      >
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-light text-[10px] font-bold text-primary">
          L
        </div>
        <div className="flex-1">
          <p className="text-[10px] font-semibold">Layla Yousef</p>
          <p className="text-[9px] text-gray-500">Room 3 · ICU</p>
          <span
            className={`mt-1 inline-flex rounded-full bg-critical-light px-1.5 py-0.5 text-[8px] font-semibold text-critical transition-all duration-400 ${
              phase >= 4 ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'
            }`}
          >
            1 overdue
          </span>
        </div>
        <Star className="h-3.5 w-3.5 fill-favorite text-favorite" />
      </div>

      <div
        className={`flex items-center gap-2 rounded-lg border bg-white p-2 shadow-sm transition-all duration-400 ${
          khalidSelected ? 'border-primary-ring' : 'border-gray-200'
        }`}
      >
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-light text-[10px] font-bold text-primary">
          K
        </div>
        <div className="flex-1">
          <p className="text-[10px] font-semibold">Khalid Mansour</p>
          <p className="text-[9px] text-gray-500">Room 8 · Ward A</p>
        </div>
        <Star
          className={`h-3.5 w-3.5 transition-all duration-300 ${
            khalidFavorited ? 'scale-110 fill-favorite text-favorite' : 'scale-100 text-gray-300'
          }`}
        />
      </div>

      <div
        className={`rounded-lg border border-dashed border-gray-300 bg-gray-50 p-2 text-center transition-opacity duration-400 ${
          khalidSelected ? 'opacity-100' : 'opacity-60'
        }`}
      >
        <Users className="mx-auto mb-1 h-4 w-4 text-gray-400" />
        <p className="text-[9px] text-gray-500">Tap a patient to open details</p>
      </div>
      </div>
    </div>
  );
}
